<template>
  <div class="popup-noti-send-mail">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false" :custom-class="site == $siteType.site_partner ? 'dialog-partner' : '' ">
      <div class="popup-header">
        <p class="title">
          {{ $t('send_mail_completed') }}
        </p>
        <p class="description">
          ご入力いただいたメールアドレス宛にメールをお送りしました。<br>
          内容をご確認の上、管理画面へログインしてください。
        </p>
      </div>
      <div class="popup-main" v-if="site == $siteType.site_partner">
        <div class="popup-main-child">
          <p class="noti-main-title">
            <img class="note-icon" src="/images/icons8-note.svg" /><span>メールが届かない場合</span>
          </p>
          <div class="noti-main-content">
            <p>
              （1）迷惑メールフォルダ内にメールが届いていないかご確認ください。<br>
              （2）メールアドレスが誤っていた場合は、お手数ですが再度メールアドレスのご入力をお願いします。
            </p>
            <p>
              上記でもメールが届かない場合は、誠に恐縮ですが <el-link type="primary" :href="this.userSiteDomain +'/other_user_contacts/create'" class="link-contact" :underline="false">問い合わせフォーム</el-link>よりご連絡くださいませ。
            </p>
          </div>
        </div>
      </div>
      <el-button class="btn" @click="back">{{ $t('btn_back_login') }}</el-button>
    </el-dialog>
  </div>
</template>
<script>
  import { USER_SITE_DOMAIN } from "./../../constants"
  export default {
    props: {
      openNotiSendMail: { type: Boolean, required: true, default: false },
      site: { type: Number, required: false }
    },
    emits: ['isClosePopupNoti'],
    data() {
      return {
        outerVisible: false,
        innerVisible: false,
        dialog: '',
        isClose: false,
        userSiteDomain: USER_SITE_DOMAIN,
      };
    },
    methods: {
      handleClose() {
        this.$emit('isClosePopupNoti');
      },
      back() {
        this.$emit('isClosePopupNoti');
      }
    },
    created() {
      this.dialog = this.openNotiSendMail;
    },
    computed: {
    }
  }
</script>

<style lang="scss">
  .popup-noti-send-mail {
    .el-dialog {
      --el-dialog-width: 760px;
      --el-dialog-margin-top: 8vh;
      height: 611px;
      .el-dialog__body {
        margin-top: 20%;
      }
    }
    .dialog-partner {
      .el-dialog__body {
        margin-top: 0;
      }
    }
  }
</style>
